import { lazy, Suspense, useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';

import { photoViewerTargetAtom } from './photo-viewer-atom';

/** Lazy-loaded viewer — keeps the gesture layer out of the page chunk. */
const MobilePhotoViewer = lazy(() =>
    import('./MobilePhotoViewer').then((module) => ({
        default: module.MobilePhotoViewer,
    })),
);

/**
 * Mount point for the mobile photo viewer. Subscribing to the target here
 * rather than in the page keeps opening and closing the viewer off the page's
 * render path, and means its chunk is only fetched on the first tap.
 */
export const MobilePhotoViewerMount = () => {
    const target = useAtomValue(photoViewerTargetAtom);
    const setTarget = useSetAtom(photoViewerTargetAtom);

    // The atom outlives the page, so leaving one with the viewer open (a back
    // swipe, any client navigation) would strand a target that reopens the
    // viewer unbidden on the next product — against media it doesn't own.
    useEffect(() => () => setTarget(null), [setTarget]);

    if (!target) return null;

    return (
        <Suspense fallback={null}>
            <MobilePhotoViewer />
        </Suspense>
    );
};
